import type {UserEvent, UserEventDetailComponentProps} from '@cohort/merchants/apps';
import type {CohortAppConnectedEventStruct} from '@cohort/shared/apps/cohort/userEvents/appConnected';
import {CohortAppConnectedEventSpec} from '@cohort/shared/apps/cohort/userEvents/appConnected';
import {Trans} from 'react-i18next';

const DetailComponent: React.FC<UserEventDetailComponentProps> = ({userEvent}) => {
  const properties = userEvent.properties as CohortAppConnectedEventStruct['Properties'];
  const appName = properties.appId;
  return (
    <Trans
      i18nKey="userEvents.app.connected.detail"
      ns="app-cohort"
      values={{
        appName,
      }}
      components={{
        bold: <span className="font-semibold text-gray-900" />,
      }}
    />
  );
};

export const CohortAppConnectedUserEvent: UserEvent<CohortAppConnectedEventStruct> = {
  spec: CohortAppConnectedEventSpec,
  detailComponent: DetailComponent,
};
